import { useAuth } from '../contexts/AuthContext.jsx';

/**
 * Custom hook for easy access to authentication session data
 * Provides a simplified interface for common auth operations
 */
export const useAuthSession = () => {
  const auth = useAuth();
  
  return {
    // Session state
    user: auth.user,
    isAuthenticated: auth.isAuthenticated,
    isLoading: auth.isLoading,
    isInitialized: auth.isInitialized,
    
    // Session actions
    login: auth.login,
    logout: auth.logout,
    refreshUser: auth.refreshUser,
    
    // User info helpers
    username: auth.user?.username,
    email: auth.user?.email,
    roles: auth.user?.roles || [],
    
    // Permission helpers
    hasRole: auth.hasRole,
    hasAnyRole: auth.hasAnyRole,
    
    // API helpers
    getAuthHeaders: auth.getAuthHeaders,
    authenticatedRequest: auth.authenticatedRequest,
    retryPendingRequests: auth.retryPendingRequests,
    clearPendingRequests: auth.clearPendingRequests,
    
    // Utility functions
    isAdmin: () => auth.hasRole('admin'),
    isModerator: () => auth.hasRole('moderator'),
    canCreateTournament: () => auth.isAuthenticated,
    canEditTournament: (tournament) => {
      if (!auth.isAuthenticated) return false;
      if (auth.hasRole('admin')) return true;
      // Add more specific logic here if needed
      return false;
    }
  };
};
